import React from 'react';
import { profileIsOfficial, profileShowsEmployeeBadge, type ProfileBadgeSource } from '../../lib/profileBadgeFlags';

type Props = {
  profile?: ProfileBadgeSource | null;
  isOfficial?: boolean;
  isEmployee?: boolean;
  className?: string;
  size?: 'xs' | 'sm';
};

const sizeClasses = {
  xs: 'text-[10px] px-1.5 py-0.5',
  sm: 'text-xs px-2 py-0.5',
};

/** Official (@district88) or Employee staff tag — never both. */
export const OfficialOrEmployeeBadge: React.FC<Props> = ({
  profile,
  isOfficial: isOfficialProp,
  isEmployee: isEmployeeProp,
  className = '',
  size = 'sm',
}) => {
  const official =
    isOfficialProp ?? (profile ? profileIsOfficial(profile) : false);
  const employee =
    isEmployeeProp ?? (profile ? profileShowsEmployeeBadge(profile) : false);

  const sz = sizeClasses[size];

  if (official) {
    return (
      <span
        className={`bg-red-500/20 text-red-400 rounded-full border border-red-500/40 font-medium ${sz} ${className}`}
      >
        Official
      </span>
    );
  }

  if (employee) {
    return (
      <span
        className={`bg-amber-500/20 text-amber-400 rounded-full border border-amber-500/30 font-medium ${sz} ${className}`}
      >
        Employee
      </span>
    );
  }

  return null;
};
